var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsCircleReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EF5E3B",
    fillRule: "evenodd",
    d: "M21.5 11.75c0 5.385-4.365 9.75-9.75 9.75S2 17.135 2 11.75 6.365 2 11.75 2s9.75 4.365 9.75 9.75zm-18 0c0 4.556 3.694 8.25 8.25 8.25S20 16.306 20 11.75 16.306 3.5 11.75 3.5 3.5 7.194 3.5 11.75zm7.5 4c0-.414.336-.75.75-.75s.75.336.75.75-.336.75-.75.75-.75-.336-.75-.75zm0-3v-5c0-.414.336-.75.75-.75s.75.336.75.75v5c0 .414-.336.75-.75.75s-.75-.336-.75-.75z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsCircleReport);
export default __webpack_public_path__ + "static/media/icons-circle-report.654679e3072b73a98921f9352779178a.svg";
export { ForwardRef as ReactComponent };